import { Component } from 'react';

// Ловить будь-яку необроблену помилку рендеру десь у дереві застосунку і
// показує людяне повідомлення замість голого чорного/білого екрана.
// Найпоширеніший реальний випадок (побачено на живому кейсі, 04.08.2026):
// увімкнений автопереклад Chrome підміняє текстові DOM-вузли, і React потім
// падає з DOMException (removeChild/insertBefore) при наступному рендері —
// без цього boundary весь застосунок розмонтовувався в чорний екран.
// Основний захист — заборона автоперекладу (translate="no" в index.html),
// це запобіжник на випадок будь-якої іншої непередбаченої помилки рендеру.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', background: '#141414', color: '#eee',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: 'Arial, sans-serif', padding: '24px', textAlign: 'center',
        }}>
          <div style={{ maxWidth: '420px' }}>
            <h2 style={{ margin: '0 0 12px', fontSize: '20px' }}>⚠️ Something went wrong</h2>
            <p style={{ color: '#aaa', fontSize: '14px', lineHeight: 1.6, margin: '0 0 20px' }}>
              The page hit an unexpected error. If your browser is set to auto-translate this page,
              try turning translation off for this site — that's the most common cause.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#e2434f', border: 'none', color: '#fff',
                padding: '10px 24px', borderRadius: '8px', fontSize: '14px',
                fontWeight: 'bold', cursor: 'pointer',
              }}>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
